import './unreported-statsig-initialisation-error.tsx';
import { unreportedStatsigInitialisationErrorState } from './unreportedStatsigInitialisationErrorState.tsx';

export const setUnreportedStatsigInitialisationError = (error: Error): void => {
	unreportedStatsigInitialisationErrorState.set(error);
};
